/**
 * ODDFISH — Footer CTA hover strikes (underline on hover/focus only)
 */
(function () {
  "use strict";

  var REDUCED_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)");

  function prefersReducedMotion() {
    return REDUCED_MOTION.matches;
  }

  function isDesignMode() {
    if (window.Shopify && window.Shopify.designMode) return true;

    try {
      if (window.parent !== window && window.parent.Shopify && window.parent.Shopify.designMode) {
        return true;
      }
    } catch (error) {
      /* cross-origin iframe */
    }

    if (document.documentElement.classList.contains("shopify-design-mode")) return true;
    if (document.body && document.body.classList.contains("shopify-design-mode")) return true;
    if (/[?&]oseid=/.test(window.location.search)) return true;

    return false;
  }

  function clearStrike(btn) {
    if (!btn) return;
    delete btn.dataset.oddfishStrikeLocked;
    btn.classList.remove("strike-visible");
  }

  function bindHover(link) {
    if (!link || link.dataset.oddfishCtaBound) return;
    link.dataset.oddfishCtaBound = "true";

    link.addEventListener("mouseenter", function () {
      var btn = link.querySelector(".services_btn");
      if (btn) btn.classList.add("strike-visible");
    });

    link.addEventListener("mouseleave", function () {
      clearStrike(link.querySelector(".services_btn"));
    });

    link.addEventListener("focusin", function () {
      var btn = link.querySelector(".services_btn");
      if (btn) btn.classList.add("strike-visible");
    });

    link.addEventListener("focusout", function () {
      clearStrike(link.querySelector(".services_btn"));
    });
  }

  function markRevealed(link) {
    link.classList.add("is-revealed");
  }

  function bindScrollReveal(root) {
    root.classList.add("js-ready");

    if (prefersReducedMotion() || isDesignMode()) {
      root.querySelectorAll(".service_link").forEach(markRevealed);
      return;
    }

    if (!("IntersectionObserver" in window)) {
      root.querySelectorAll(".service_link").forEach(markRevealed);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          markRevealed(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: "0px 0px 8% 0px" }
    );

    root.querySelectorAll(".service_link").forEach(function (link) {
      if (!link.classList.contains("is-revealed")) {
        observer.observe(link);
      }
    });
  }

  function resetFooterCta(root) {
    if (!root) return;
    delete root.dataset.oddfishFooterCtaInit;
    root.classList.remove("js-ready");
    root.querySelectorAll(".service_link").forEach(function (link) {
      delete link.dataset.oddfishCtaBound;
      link.classList.remove("is-revealed");
      clearStrike(link.querySelector(".services_btn"));
    });
  }

  function initFooterCta(root) {
    if (!root || root.dataset.oddfishFooterCtaInit) return;
    root.dataset.oddfishFooterCtaInit = "true";

    root.querySelectorAll(".service_link").forEach(function (link) {
      clearStrike(link.querySelector(".services_btn"));
      bindHover(link);
    });
    bindScrollReveal(root);
  }

  function boot(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    container.querySelectorAll(".oddfish-footer-cta").forEach(initFooterCta);
  }

  function reinitAllFooters() {
    document.querySelectorAll(".oddfish-footer-cta").forEach(function (root) {
      resetFooterCta(root);
      initFooterCta(root);
    });
  }

  window.OddfishFooterCta = { boot: boot, reinitAll: reinitAllFooters };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
    if (event.target && !event.target.querySelector(".oddfish-footer-cta")) {
      reinitAllFooters();
    }
  });

  document.addEventListener("shopify:section:unload", function () {
    window.setTimeout(reinitAllFooters, 0);
  });

  document.addEventListener("shopify:section:select", function () {
    if (!isDesignMode()) return;
    reinitAllFooters();
  });

  REDUCED_MOTION.addEventListener("change", function () {
    reinitAllFooters();
  });
})();
